// The stepSubtitle values from be form.js files
export const stepSubtitles = {
  Address: "Address",
  BeneficiaryInformation: "Beneficiary Information",
  Contact: "Contact",
  Employment: "Employment",
  Financial: "Financial",
  IdentityVerification: "Identity Verification",
  InvestmentObjective: "Investment Objective",
  InvestmentPreferences: "Investment Preferences",
  JointHolderFinancial: "Joint Holder Financial",
  JointHolderPersonal: "Joint Holder Personal",
  MinorAccountInformation: "Minor's Account Information",
  Personal: "Personal",
  TrustedContact: "Trusted Contact",
};
